
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.75 11a9.75 9.75 0 11-19.5 0 9.75 9.75 0 0119.5 0z","fill":"#fff","stroke":"#fff","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M10.25 9.5H11v6.75h.75","stroke":"#1D1B25","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('mask',{staticStyle:{"mask-type":"luminance"},attrs:{"id":"a","maskUnits":"userSpaceOnUse","x":"9","y":"5","width":"4","height":"3"}},[_c('path',{attrs:{"d":"M12.125 6.125a1.125 1.125 0 11-2.25 0 1.125 1.125 0 012.25 0z","fill":"#fff"}})]),_c('g',{attrs:{"mask":"url(#a)"}},[_c('path',{attrs:{"d":"M12.125 6.125a1.125 1.125 0 11-2.25 0 1.125 1.125 0 012.25 0z","fill":"#1D1B25","stroke":"#1D1B25","stroke-width":"1.5"}})])])
          )
        }
      }
    